<template>
  <ThreadCompact class="thread-compact-header">
    <template #recipients>
      <strong class="recipient-header">{{ $getText('MESSAGE_SENT_TO') }}</strong>
    </template>
    <template #name>
      <strong>{{ $getText('MESSAGE_LABEL_SUBJECT') }}</strong>
    </template>
    <template #date>
      <strong>{{ $getText('MESSAGE_LABEL_DATE') }}</strong>
    </template>
  </ThreadCompact>
</template>
<script>
import ThreadCompact from './ThreadCompact';
export default {
  components: { ThreadCompact },
};
</script>
<style scoped lang="scss">
.thread-compact-header {
  position: sticky;
  top: 0;
  z-index: var(--sticky-header-z-index);
  .recipient-header {
    padding-left: 52px;
  }
}
</style>
